import { render, staticRenderFns } from "./RegisterSolution.vue?vue&type=template&id=0dfb879a"
import script from "./RegisterSolution.vue?vue&type=script&lang=js"
export * from "./RegisterSolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports